@if (initialized) {
  <div>
    <forge-date-picker [(ngModel)]="valueModel" [name]="Name" [min]="minDateString" [max]="maxDateString" [required]="isRequired" show-today [attr.year-range]="yearRange">
      <forge-text-field #pickerTextField [density]="Density" [invalid]="isInvalid" [required]="isRequired"
        [ngClass]="{'dense-input': dense || compact, 'cell-edit': forCellEdit}"
        [attr.label-position]="LabelPosition" [attr.shape]="forCellEdit ? 'squared' : null">
        <input #input id="txt_date_{{Name}}" type="text" focusOnLoad [propertyMetadata]="propertyMetadata" [forCellEdit]="forCellEdit"
          [disabled]="isViewOnly" [required]="isRequired" (blur)="fireValueChanged()" (keydown)="onKeyDown($event)"
          (input)="onInputChange($event)" attr.telemetry="Date picker-{{Label}}" tabindex="0">
          <label for="txt_date_{{Name}}">{{Label}}</label>
          @if (hint && !dense && !compact && !isInvalid) {
            <span slot="support-text">{{hint}}</span>
          }
          @if (isInvalid && !dense && !compact && !outOfRange) {
            <span slot="support-text"
            class="error-red">{{error}}</span>
          }
          @if (!dense && !compact && outOfRange) {
            <span slot="support-text" class="error-red">{{outOfRangeMsg}}</span>
          }
          @if (showSpinner) {
            <forge-circular-progress class="metadata-input--spinner" slot="end">
            </forge-circular-progress>
          }
        </forge-text-field>
      </forge-date-picker>
    </div>
  }
